import { Injectable } from '@angular/core'
import { DataService } from '@vendure/admin-ui/core'

import { GetNextPxlStatesDocument, TransitionPxlToStateDocument } from '../generated/ui-types'

@Injectable()
export class PxlStateDataService {
    constructor(private dataService: DataService) {}

    getNextStates(id: string) {
        return this.dataService.query(GetNextPxlStatesDocument, {
            id,
        })
    }

    transitionToState(id: string, state: string) {
        return this.dataService.mutate(TransitionPxlToStateDocument, {
            id,
            state,
        })
    }
}
